export { default } from './MSCCInspectionProps.component';
